const LoadingState = {
  template: `
    <div class="loading-state-overlay">
      <div class="loading-state">
        <div class="loading-spinner"></div>
        <p>Submitting form, please wait…</p>
      </div>
    </div>
  `,
  data() {
    return {
      isLoading: true
    }
  }
}


const SuccessMessage = {
  template: `
    <div class="success-overlay">
      <div class="success-message-box">
       
        <h2>Your form has been submitted.</h2>

        <p>We will get back to you as soon as possible.</p>
        <button @click="redirectToStore">Back To The Store</button>
      </div>
    </div>
  `,
   methods: {
    redirectToStore() {
      window.location.href = 'https://maxilite.lighting/'; // Replace with your specific URL
    }
  }
};

const MenuContainer = {
  props: {
    currentStep: {
      type: String,
      required: true
    }
  },
  emits: ['serviceSelection', 'goBack'],
  data() {
    return {
      serviceOptions: {
        'service-center': {
          heading: 'Service Center',
          options: [
            { step: 'missing-damaged', label: 'Missing or damaged parts' },
            { step: 'finish-defect', label: 'Finish defect' },
            { step: 'light-issue', label: 'Light source' },
            { step: 'dimming-issue', label: 'Dimming issue' },
            { step: 'warranty', label: 'Warranty' }
          ]
        },
        'light-issue': {
          heading: 'Light source',
          options: [
            { step: 'mx-isssue-light', label: 'MX (E14 or E26 Socket)' },
            { step: 'mxa-light', label: 'MXA (AC LED)' },
            { step: 'mxl-light', label: 'MXL (0-10V Dimming - DC LED)' },
            { step: 'mxd-light', label: 'MXD (ELV Dimming - DC LED)' },
            { step: 'mxe-light', label: 'MXE (Compact Fluorescent)' }
          ]
        },
        'dimming-issue': {
          heading: 'Dimming issue',
          options: [
            { step: 'mx-isssue', label: 'MX (E14 or E26 Socket)' },
            { step: 'mxa', label: 'MXA (AC LED)' },
            { step: 'mxl', label: 'MXL (0-10V Dimming - DC LED)' },
            { step: 'mxd', label: 'MXD (ELV Dimming - DC LED)' },
            { step: 'mxe', label: 'MXE (Compact Fluorescent)' }
          ]
        }
      },
      pdfLinks: {
        mxa: 'https://maxilitelighting.com/extra_files/elv_triac_dimming_9-8-2024.pdf',
        mxl: 'https://maxilitelighting.com/extra_files/0-10v_dimming_9-8-2024.pdf',
        mxd: 'https://maxilitelighting.com/extra_files/elv_dimming_9-8-2024.pdf',
        mxe: 'https://maxilitelighting.com/extra_files/0-10v_dimming_9-8-2024.pdf',
        warranty: 'https://maxilitelighting.com/extra_files/limited_warranty_9-8-2024.pdf',
      },
    };
  },
  methods: {
    handleServiceSelection(step) {
      if (['mxa', 'mxl', 'mxd', 'mxe', 'warranty'].includes(step)) {
        this.openLink(step); // Open the PDF link in a new tab
      } else {
         this.$emit('serviceSelection', step);
      }
    },
    openLink(step) {
      // Open the corresponding PDF link in a new tab
      if (this.pdfLinks[step]) {
        window.open(this.pdfLinks[step], '_blank');
      }
    },
    goBack() {
      this.$emit('goBack');
    }
  },
  computed: {
    showBackButton() {
      return this.currentStep !== 'service-center';
    }
  },
  template: `
    <div v-if="serviceOptions[currentStep]" class="service-center" :class="currentStep">
      <div v-if="showBackButton" class="back-btn-container">
        <button class="back-btn" @click="goBack">
          <svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 48 48">
            <g fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="4">
              <path d="M12 23.9917H36" />
              <path d="M24 36L12 24L24 12" />
            </g>
          </svg>
        </button>
      </div>
      <h2>{{ serviceOptions[currentStep].heading }}</h2>
      <div class="button-container">
        <p>What do you need help with?</p>
        <button v-for="option in serviceOptions[currentStep].options" :key="option.step" class="service-btn" @click="handleServiceSelection(option.step)">
          {{ option.label }}
        </button>
      </div>
    </div>
  `
};






const PhoneNumberForm = {
  props: {
    label: {
      type: String,
      required: true
    },
    phoneField: {
      type: String,
      required: true
    },
    formData: {
      type: Object,
      required: true
    }
  },
  template: `
    <div class="form-group">
      <label :for="phoneField">{{ label }}</label>
      <input type="text" :id="phoneField" v-model="formData[phoneField]" @input="formatPhoneNumber" maxlength="14" />
    </div>
  `,
  methods: {
    formatPhoneNumber() {
      let input = this.formData[this.phoneField].replace(/\D/g, '').substring(0, 10);
      const size = input.length;
  
      if (size === 0) {
        input = '';
      } else if (size < 4) {
        input = `(${input}`;
      } else if (size < 7) {
        input = `(${input.substring(0, 3)}) ${input.substring(3)}`;
      } else {
        input = `(${input.substring(0, 3)}) ${input.substring(3, 6)}-${input.substring(6)}`;
      }
      this.formData[this.phoneField] = input;
    }
  }  
};



const SiteAddressForm = {
  components: {
    PhoneNumberForm,  
  },
  props: {
    formData: {
      type: Object,
      required: true
    }
  },
  template: `
    <div>
      <div class="form-group">
        <label for="site_address">Site Address</label>
        <input id="site-address" type="text" ref="siteAddressInput" v-model="formData.site_address" />
      </div>
      <div class="double-row">
        <div class="form-group">
          <label for="city">City</label>
          <input id="city" type="text" ref="cityInput" v-model="formData.city" />
        </div>
        <div class="form-group">
          <label for="province">Province/State</label>
          <input id="province" type="text" ref="provinceInput" v-model="formData.province" />
        </div>
      </div>
      <div class="double-row">
        <div class="form-group">
          <label for="country">Country</label>
          <input id="country" type="text" v-model="formData.country" />
        </div>
        <div class="form-group">
          <label for="postal_code">Postal Code</label>
          <input id="postal_code" type="text" v-model="formData.postal_code" />
        </div>
      </div>
      <PhoneNumberForm 
        :label="'Site Phone Number'" 
        :phoneField="'site_phone'" 
        :formData="formData" 
      />
    </div>
  `,
  mounted() {
    this.initAutocomplete();
  },
  methods: {
    initAutocomplete() {
      const siteAddressInput = this.$refs.siteAddressInput;
      if (siteAddressInput instanceof HTMLInputElement) {
        const autocomplete = new google.maps.places.Autocomplete(
          siteAddressInput,
          {
            types: ['geocode'],
            componentRestrictions: { country: ['us', 'ca'] } // Example: restrict to US and Canada
          }
        );

        // Prevent form submission on Enter key
        siteAddressInput.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
          }
        });

        // Set address details from Google Autocomplete
        autocomplete.addListener('place_changed', () => {
          const place = autocomplete.getPlace();
          let street = '';
          let street_number = '';

          place.address_components.forEach((component) => {
            const types = component.types;
            if (types.includes('street_number')) {
              street_number = component.long_name;
            }
            if (types.includes('route')) {
              street = component.long_name;
            }
            if (types.includes('locality')) {
              this.formData.city = component.long_name;
            }
            if (types.includes('administrative_area_level_1')) {
              this.formData.province = component.long_name;
            }
            if (types.includes('country')) {
              this.formData.country = component.long_name;
            }
            if (types.includes('postal_code')) {
              this.formData.postal_code = component.long_name;
            }
          });

          this.formData.site_address = `${street_number} ${street}`.trim();
        });
      } else {
        console.error('Site address input is not a valid HTMLInputElement.');
      }
    }
  }
};



// Custom Select Component for Vue 3
const CustomSelect = {
  props: ['options', 'modelValue'],
  data() {
    return {
      isOpen: false,
      selectedOption: this.modelValue,
    };
  },
  template: /*html*/`
    <div class="custom-select">
      <div class="custom-select-toggle" @click="toggleDropdown">
        {{ selectedOption ? selectedOption : 'Select one...' }}
        <!-- SVG icon -->
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
            <g fill="none" fill-rule="evenodd">
            <path d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"/>
            <path fill="currentColor" d="M12.707 15.707a1 1 0 0 1-1.414 0L5.636 10.05A1 1 0 1 1 7.05 8.636l4.95 4.95l4.95-4.95a1 1 0 0 1 1.414 1.414z"/>
            </g>
          </svg>
      </div>
      <div v-if="isOpen" class="custom-select-options">
        <div 
          v-for="option in options" 
          :key="option" 
          class="custom-select-option" 
          @click="selectOption(option)">
          {{ option }}
        </div>
      </div>
    </div>
  `,
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    selectOption(option) {
      this.selectedOption = option;
      this.$emit('update:modelValue', option);
      this.isOpen = false;
    },
    closeDropdown() {
      this.isOpen = false;
    },
  },
  mounted() {
    this.clickOutsideHandler = (event) => {
      if (!this.$el.contains(event.target)) {
        this.closeDropdown();
      }
    };
    document.addEventListener('click', this.clickOutsideHandler);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.clickOutsideHandler);
  },
  watch: {
    modelValue(newVal) {
      this.selectedOption = newVal;
    }
  }
};

  
  // Custom File Input Component for Vue 3
  const CustomFileInput = {
    props: ['modelValue'],
    data() {
      return {
        files: this.modelValue || [],
        inputId: 'fileInput-' + Math.random().toString(36).substring(7),
        isDragging: false,
      };
    },
    template: `
      <div 
        class="file-container" 
        @dragover.prevent="handleDragOver" 
        @dragleave="handleDragLeave"
        @drop.prevent="handleDrop"
        :class="{ 'dragging': isDragging }"
      >
        <input :id="inputId" type="file" @change="handleFileChange" class="file-input" multiple>
        <label :for="inputId" class="file-label">
          <span v-if="!isDragging">Choose or Drag & Drop Files Here</span>
          <span v-if="isDragging">Drop Files to Upload</span>
        </label>
  
        <div v-if="files.length > 0" class="file-list">
          <ul>
            <li v-for="(file, index) in files" :key="index" class="file-item">
              <div class="file-info">
                {{ file.name }}
              </div>
              <button @click="removeFile(index)" type="button" class="remove-btn">
                Remove
              </button>
            </li>
          </ul>
        </div>
        <div v-else class="file-name">No files chosen</div>
      </div>
    `,
    methods: {
      handleFileChange(event) {
        const selectedFiles = Array.from(event.target.files);
        this.compressAndAddFiles(selectedFiles);
      },
      handleDragOver() {
        this.isDragging = true;
      },
      handleDragLeave() {
        this.isDragging = false;
      },
      handleDrop(event) {
        const droppedFiles = Array.from(event.dataTransfer.files);
        this.compressAndAddFiles(droppedFiles);
        this.isDragging = false;
      },
      compressAndAddFiles(newFiles) {
        const existingFileNames = this.files.map(file => file.name);
      
        // Filter out duplicate files by name
        const filteredFiles = newFiles.filter(file => !existingFileNames.includes(file.name));
      
        // Compress each image and add to the file list
        filteredFiles.forEach((file) => {
          if (file.type.startsWith('image/')) {
            const initialSize = file.size / 1024; // Initial size in KB
      
            // Compress the image using Compressor.js
            new Compressor(file, {
              mimeType: 'image/jpeg', // Set MIME type to JPEG
              quality: 0.6, // Adjust quality to 0.6
              maxWidth: 1920, // Set maximum width
              maxHeight: 1080, // Set maximum height
              success: (compressedFile) => {
                const compressedSize = compressedFile.size / 1024; // Compressed size in KB
                console.log(`File: ${file.name}`);
                console.log(`Initial Size: ${initialSize.toFixed(2)} KB`);
                console.log(`Compressed Size: ${compressedSize.toFixed(2)} KB`);
      
                // Add the compressed file to the files array
                this.files = [...this.files, compressedFile];
                this.$emit('update:modelValue', this.files); // Update the parent component
              },
              error(err) {
                console.error('Compression failed:', err);
              }
            });
          } else {
            // Add non-image files directly
            this.files = [...this.files, file];
            this.$emit('update:modelValue', this.files);
          }
        });
      },
      removeFile(index) {
        this.files.splice(index, 1);
        this.$emit('update:modelValue', this.files);
      },
    },
    watch: {
      modelValue(newVal) {
        this.files = newVal || [];
      }
    }
  };
  
  

  
const ProductInformationForm = {
  components: {
    'custom-select': CustomSelect
  },
  props: {
    formData: {
      type: Object,
      required: true
    },
    applicationOptions: {
      type: Array,
      required: true
    },
    locationOptions: {
      type: Array,
      required: true
    },
    voltageOptions: {
      type: Array,
      required: true
    }
  },
  template: `
    <div class="sub-form-container">
      <!-- Product Information -->
      <div class="double-row">
        <div class="form-group">
          <label for="product_number">Product Number</label>
          <input type="text" v-model="formData.product_number" />
        </div>
        <div class="form-group">
          <label for="installation_date">Date of Installation</label>
          <input type="date" v-model="formData.installation_date" />
        </div>
      </div>
      <div class="form-group custom-select-group">
        <label for="application">Application</label>
        <custom-select 
          v-model="formData.application" 
          :options="applicationOptions">
        </custom-select>
      </div>
      <div class="double-row">
        <div class="form-group custom-select-group">
          <label for="location">Location</label>
          <custom-select 
            v-model="formData.location" 
            :options="locationOptions">
          </custom-select>
        </div>
        <div class="form-group custom-select-group">
          <label for="voltage">Voltage</label>
          <custom-select 
            v-model="formData.voltage" 
            :options="voltageOptions">
          </custom-select>
        </div>
      </div>
      <div class="form-group">
        <label for="units_installed">Number of Units Installed</label>
        <input type="text" v-model="formData.units_installed" />
      </div>
    </div>
  `
};

const CustomerInformationForm = {
  components: {
    'PhoneNumberForm': PhoneNumberForm
  },
  props: {
    formData: {
      type: Object,
      required: true
    },
    errors: {
       type: Object,
      required: true
    }
  },
  template: `
    <div class="sub-form-container">
      <div class="double-row">
        <div class="form-group">
          <label for="customer_name">Customer Name<span class="required">*</span></label>
          <input type="text" v-model="formData.customer_name" :class="{ 'input-error': errors.customer_name }"  />
          <p v-if="errors.customer_name" class="error-message">Customer Name is required.</p>
        </div>
        <div class="form-group">
          <label for="customer_email">Email Address<span class="required">*</span></label>
          <input type="text" v-model="formData.customer_email" :class="{ 'input-error': errors.customer_email }" />
          <p v-if="errors.customer_email" class="error-message">A valid Email Address is required.</p>
        </div>
      </div>
      <PhoneNumberForm 
        :label="'Customer Phone Number'" 
        :phoneField="'customer_phone'" 
        :formData="formData" 
      />
    </div>
  `
};

const SalesAssociateInformationForm = {
  components: {
    'PhoneNumberForm': PhoneNumberForm
  },
  props: {
    formData: {
      type: Object,
      required: true
    }
  },
  template: `
    <div class="sub-form-container">
      <div class="double-row">
        <div class="form-group">
          <label for="sales_associate_name">Sales Associate Name</label>
          <input type="text" v-model="formData.sales_associate_name" />
        </div>
        <div class="form-group">
          <label for="email_address">Email Address</label>
          <input type="text" v-model="formData.email_address" />
        </div>
      </div>
      <PhoneNumberForm 
        :label="'Sales Associate Phone Number'" 
        :phoneField="'sales_associate_phone'" 
        :formData="formData" 
      />
      <div class="form-group">
        <label for="distributors_po">Distributors PO #</label>
        <input type="text" v-model="formData.distributors_po" />
      </div>
    </div>
  `
};



const DefectDetailsForm = {
  components: {
    'custom-file-input': CustomFileInput
  },
  props: {
    formData: {
      type: Object,
      required: true
    },
    fileFields: {
      type: Array,
      default: () => [{ label: 'Upload images of the defect', model: 'defect_image' }]
    }
  },
  template: `
    <div class="sub-form-container">
      <div class="form-group">
        <label for="defect_description">Describe the defect</label>
        <input type="text" v-model="formData.defect_description" />
      </div>
      <div v-for="field in fileFields" :key="field.model" class="form-group">
        <label :for="field.model">{{ field.label }}</label>
        <custom-file-input v-model="formData[field.model]"></custom-file-input>
      </div>
    </div>
  `
};


const InfoDisplay = {
  props: {
    message: {
      type: String,
      required: true
    }
  },
  template: `
    <div class="info-display-component">
      <p v-text="message"></p>
    </div>
  `
}



const FormContainer = {
  components: {
    SalesAssociateInformationForm,
    CustomerInformationForm,
    SiteAddressForm,
    ProductInformationForm,
    DefectDetailsForm,
    InfoDisplay,
    SuccessMessage,
    LoadingState
  },
  props: {
    currentStep: {
      type: String,
      required: true
    },
    applicationOptions: {
      type: Array,
      required: true
    },
    locationOptions: {
      type: Array,
      required: true
    },
    voltageOptions: {
      type: Array,
      required: true
    }
  },
  emits: ['goBack'],
  data() {
    return {
      isLoading: false,
      formData: {
        sales_associate_name: '',
        email_address: '',
        sales_associate_phone: '',
        distributors_po: '',
        customer_name: '',
        customer_email: '',
        customer_phone: '',
        site_address: '',
        city: '',
        province: '',
        postal_code: '',
        country: '',
        site_phone: '',
        product_number: '',
        installation_date: '',
        application: '',
        location: '',
        voltage: '',
        units_installed: '',
        defect_description: '',
        defect_image: [],
        defect_image_socket: [],
        defect_image_fixture: [],
        defect_image_module: [],
        defect_image_drive: [],
        form_type: ''
      },
      successMessageVisible: false,
      errors: {
        customer_name: false,
        customer_email: false
      }
    };
  },
  methods: {
    goBack() {
      this.$emit('goBack');
    },
    appendFilesToFormData(formData, fieldName, filesArray) {
      // Check if the filesArray exists and is an array before proceeding
      if (Array.isArray(filesArray) && filesArray.length > 0) {
        filesArray.forEach((file, index) => {
          formData.append(`${fieldName}[${index}]`, file);
        });
      }
    },
    isValidEmail(email) {
      const re = /\S+@\S+\.\S+/;
      return re.test(email);
    },
    errorsExist() {
      return this.errors.customer_name || this.errors.customer_email
    },
    async submitForm() {
      this.isLoading = true;
      console.log('Current data: ', this.formData)

      this.errors.customer_name = !this.formData.customer_name;
      this.errors.customer_email = !this.formData.customer_email || !this.isValidEmail(this.formData.customer_email);
      

      if (this.errorsExist()) {
      console.log("Please fill all required fields");
      alert("Please fill all required fields!");
      return;
      }
      
      // Create a new FormData object
  const formData = new FormData();

  // Append regular form fields
  formData.append('sales_associate_name', this.formData.sales_associate_name);
  formData.append('email_address', this.formData.email_address);
  formData.append('sales_associate_phone', this.formData.sales_associate_phone);
  formData.append('distributors_po', this.formData.distributors_po);
  formData.append('customer_name', this.formData.customer_name);
  formData.append('customer_email', this.formData.customer_email);
  formData.append('customer_phone', this.formData.customer_phone);
  formData.append('site_address', this.formData.site_address);
  formData.append('city', this.formData.city);
  formData.append('province', this.formData.province);
  formData.append('postal_code', this.formData.postal_code);
  formData.append('country', this.formData.country);
  formData.append('site_phone', this.formData.site_phone);
  formData.append('product_number', this.formData.product_number);
  formData.append('installation_date', this.formData.installation_date);
  formData.append('application', this.formData.application);
  formData.append('location', this.formData.location);
  formData.append('voltage', this.formData.voltage);
  formData.append('units_installed', this.formData.units_installed);
  formData.append('defect_description', this.formData.defect_description);
  formData.append('form_type', this.formHeading);

  // Append file fields (e.g., defect_image is an array of files)
  this.appendFilesToFormData(formData, 'defect_image', this.formData.defect_image);
  this.appendFilesToFormData(formData, 'defect_image_socket', this.formData.defect_image_socket);
  this.appendFilesToFormData(formData, 'defect_image_fixture', this.formData.defect_image_fixture);
  this.appendFilesToFormData(formData, 'defect_image_module', this.formData.defect_image_module);
  this.appendFilesToFormData(formData, 'defect_image_drive', this.formData.defect_image_drive);

      
  
      // This is going to be the production request
      const url = 'https://fast-layney-jarochosdev-766b555a.koyeb.app/api/form';
      // const testUrl = 'http://localhost:3008/api/form';
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
              'Authorization': 'Bearer required-token', 
          },
          body: formData, 
        });

        this.isLoading = false;
        if (response.ok) {
          const result = await response.json();
          console.log('Form submitted:', result);
          // this.successMessageVisible = true;
          //redirect to the success page
          //local
          // window.location.href = 'http://127.0.0.1:9292/pages/returns?success=true';
          //production
          window.location.href = 'https://maxilite.lighting/pages/returns?success=true';

          // Optionally, reset the form
          this.resetForm();
        } else {
          console.error('Form submission failed:', response.statusText);
          alert('Failed to submit the form. Please try again.');
        }
      } catch (error) {
        console.error('Error occurred during form submission:', error);
        alert('An error occurred. Please try again later.');
      }


      // This is a test request 
      // try {
      //   const response = await fetch('http://localhost:3000/api/pdf/create', {
      //     method: 'POST',
      //     body: formData, // Use FormData directly as the body
      //   });
      
      //   if (response.ok) {
      //     // Fetch the PDF response as a Blob
      //     const blob = await response.blob();
          
      //     // Create a URL for the Blob
      //     const url = window.URL.createObjectURL(blob);
      
      //     // Create a link element and trigger a download
      //     const a = document.createElement('a');
      //     a.href = url;
      //     a.download = 'output.pdf'; // The name of the PDF file
      //     document.body.appendChild(a);
      //     a.click();
      
      //     // Cleanup: remove the object URL and link element
      //     window.URL.revokeObjectURL(url);
      //     a.remove();
      
      //     alert('PDF created and downloaded successfully!');
      //   } else {
      //     console.error('Form submission failed:', response.statusText);
      //     alert('Failed to submit the form. Please try again.');
      //   }
      // } catch (error) {
      //   console.error('Error occurred during form submission:', error);
      //   alert('An error occurred. Please try again later.');
      // }



    },
    resetForm() {
      // Reset form data after submission
      Object.keys(this.formData).forEach(key => {
        this.formData[key] = '';
      });
    },
    closeSuccessMessage() {
      this.successMessageVisible = false;
    }
  },
  computed: {
    formHeading() {
      switch (this.currentStep) {
        case 'missing-damaged':
          return 'Missing or Damaged Parts';
        case 'finish-defect':
          return 'Finish Defect';
        case 'mx-isssue-light':
          return 'Light source issue with MX product';
        case 'mxa-light':
          return 'Light source issue with MXA product';
        case 'mxl-light':
          return 'Light source issue with MXL product';
        case 'mxd-light':
          return 'Light source issue with MXD product';
        case 'mxe-light':
          return 'Light source issue with MXE product';
        case 'mx-isssue':
          return 'Dimming issue with MX product';
        default:
          return 'Form';
      }
    },
    fileFields() {
      if (this.currentStep === 'missing-damaged' || this.currentStep === 'finish-defect') {
        return [
          { label: 'Upload images of the defect', model: 'defect_image' }
        ];
      } else if (this.currentStep === 'mx-isssue-light') {
        return [
          { label: 'Upload an image of the Socket', model: 'defect_image_socket' },
          { label: 'Upload an image of the Fixture', model: 'defect_image_fixture' }
        ];
      } else if (this.currentStep === 'mxa-light') {
        return [
          { label: 'Upload an image of the LED Module', model: 'defect_image_module' },
          { label: 'Upload an image of the Fixture', model: 'defect_image_fixture' }
        ];
      } else if (['mxl-light', 'mxd-light'].includes(this.currentStep)) {
        return [
          { label: 'Upload an image of the LED Module', model: 'defect_image_module' },
          { label: 'Upload an image of the LED Driver', model: 'defect_image_drive' },
          { label: 'Upload an image of the Fixture', model: 'defect_image_fixture' }
        ];
      } else {
        return [];
      }
    }
  },
  template: `
    <div class="form-container">
      <LoadingState v-if="isLoading" />

      <SuccessMessage
          v-if="successMessageVisible"
          @close="closeSuccessMessage"
        />
        
    <template v-if="!successMessageVisible">
      <!-- Back Button -->
      <div class="back-btn-container">
        <button class="back-btn" @click="goBack">
          <svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 48 48">
            <g fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="4">
              <path d="M12 23.9917H36" />
              <path d="M24 36L12 24L24 12" />
            </g>
          </svg>
        </button>
      </div>

      <!-- Form Heading -->

      
      <div class="form-heading-title">
      <h2>{{ formHeading }}</h2>
      </div>


      <!-- InfoDisplay is only for mx-isssue  -->
      <InfoDisplay v-if="currentStep === 'mx-isssue'" message="For dimming information regarding MX products, please refer to the lamp specifications that came with the product you purchased.  The specifications can usually be found on the packaging that came with the lamp when you purchased it." />

      <!-- Form Content -->
      <form v-if="currentStep !== 'mx-isssue'"  @submit.prevent="submitForm"  @keydown.enter.prevent >
        <SalesAssociateInformationForm :formData="formData" />
        <CustomerInformationForm :formData="formData" :errors="errors" />
        <SiteAddressForm :formData="formData" />
        <ProductInformationForm
          :formData="formData"
          :applicationOptions="applicationOptions"
          :locationOptions="locationOptions"
          :voltageOptions="voltageOptions"
        />
        <DefectDetailsForm 
          :formData="formData" 
          :fileFields="fileFields" 
        />
        <!-- Submit Button -->
        <button type="submit" class="submit-btn">Submit</button>
      </form>
      </template>
    </div>
  `
};



  // Main Vue 3 App
  const app = {
    components: {
      'ProductInformationForm': ProductInformationForm,
      'CustomerInformationForm': CustomerInformationForm,
      'SalesAssociateInformationForm': SalesAssociateInformationForm,
      'DefectDetailsForm': DefectDetailsForm,
      'SiteAddressForm': SiteAddressForm,
      'PhoneNumberForm': PhoneNumberForm,
      'custom-select': CustomSelect, 
      'custom-file-input': CustomFileInput,
      'MenuContainer': MenuContainer,
      'FormContainer': FormContainer
    },
    template: /*html*/`
    <div>
      <!-- Render the MenuContainer when currentStep is 'service-center' or 'dimming-issue' -->
      <MenuContainer 
        v-if="['service-center', 'dimming-issue', 'light-issue'].includes(currentStep)"
        :currentStep="currentStep" 
        @serviceSelection="handleServiceSelection"
        @goBack="goBack"
      />

      <!-- Render the FormContainer for other steps -->
      <FormContainer 
        v-else
        :currentStep="currentStep"
        :applicationOptions="applicationOptions"
        :locationOptions="locationOptions"
        :voltageOptions="voltageOptions"
        @goBack="goBack"
      />
    </div>
    `,
    data() {
      return {
        currentStep: 'service-center',
        applicationOptions: ['Commercial', 'Residential'],
        locationOptions: ['Indoor', 'Outdoor'],
        voltageOptions: ['120V', '277V', '347V'],
      };
    },
    methods: {
      handleServiceSelection(step) {
        this.currentStep = step;
      },
      goBack() {
        const dimmingIssues = ['mx-isssue'];
        const lightIssues = ['mx-isssue-light', 'mxa-light', 'mxl-light', 'mxd-light', 'mxe-light'];
        if (dimmingIssues.includes(this.currentStep)) {
          console.log("Currentstep: ", this.currentStep);
          this.currentStep = 'dimming-issue';
        } else if(lightIssues.includes(this.currentStep)){
          console.log("Currentstep: ", this.currentStep);
          this.currentStep = 'light-issue';
        } else if (this.currentStep === 'dimming-issue' || this.currentStep=== 'light-issue') {
          this.currentStep = 'service-center';
        } else if (this.currentStep === 'missing-damaged' || this.currentStep === 'finish-defect' || this.currentStep=== 'warranty') {
          this.currentStep = 'service-center';
        }
      },
    },
    mounted() {
      const style = document.createElement('style');
      style.innerHTML = /*css*/ `
        .info-display-component{
          margin-top: 3rem;
        }

        .form-heading-title{
          margin-top: 3rem;
        }

        .service-center,
        .form-container {
          width: 80%;
          margin: 20px auto;
        }

        h2 {
          text-align: center;
          color: #303030;
        }

        .button-container {
          display: flex;
          flex-direction: column;
          width: 47%;
          margin: auto;
          text-align: start;
          align-items: flex-start;
          gap: 17px;
        }

        .service-btn {
          padding: 10px 15px;
          font-size: 16px;
          border: 2px solid #767676;
          border-radius: 10px;
          cursor: pointer;
          background-color: transparent;
        }

        .form-container {
          text-align: left;
        }

        .sub-form-container {
          margin-top: 4rem;
          margin-bottom: 4rem;
        }

        .double-row {
          display: flex;
          justify-content: space-between;
        }
        .double-row .form-group {
          width: 46%;
        }

        .form-group {
          margin-bottom: 15px;
        }

        .form-group label {
          display: block;
          font-weight: 400;
          color: #1e1e1e;
          font-size: 16px;
          margin-bottom: 0.3em;
        }

        .form-group input,
        .form-group textarea {
          width: 100%;
          padding: 10px;
          margin: 5px 0;
          border: 1.5px solid #d9d9d9;
          border-radius: 5px;
        }

        .submit-btn {
          width: 100%;
          padding: 12px;
          background-color: black;
          color: white;
          border: none;
          border-radius: 5px;
          cursor: pointer;
          font-size: 1em;
        }
        .back-btn-container {
          display: flex;
          justify-content: center;
        }
        .back-btn svg {
          width: 2.5em;
          height: 2.5em;
        }
        .back-btn {
          margin-top: 10px;
          background-color: #f8f8f800;
          padding: 2px 10px;
          border: none;
          border-radius: 5px;
          cursor: pointer;
        }

        .back-btn:hover {
          background-color: #aaaaaa7e;
          transition: background-color 0.3s;
        }

        .service-center p {
          color: #000;
        }

        .service-center.dimming-issue h2{
          text-align: center;
        }
        

        /* Styling for the custom select dropdown */
        .custom-select {
          position: relative;
          width: 100%;
          font-family: Arial, sans-serif;
        }

        .custom-select-toggle {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 6px 12px;
          border: 1px solid #ccc;
          border-radius: 5px;
          cursor: pointer;
          font-size: 16px;
          width: inherit;
          transition: background-color 0.3s, border-color 0.3s;
        }

        .custom-select-toggle:hover {
          background-color: #f0f0f0;
          border-color: #bbb;
        }

        .custom-select-toggle svg {
          margin-right: 1px;
        }

        .custom-select-options {
          position: absolute;
          width: 100%;
          background-color: white;
          border: 1px solid #ccc;
          border-radius: 5px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          z-index: 1000;
          max-height: 150px;
          overflow-y: auto;
          margin-top: 5px;
          transition: max-height 0.3s;
        }

        .custom-select-option {
          padding: 10px;
          cursor: pointer;
          font-size: 16px;
        }

        .custom-select-option:hover {
          background-color: #f0f0f0;
        }

        .hidden {
          display: none;
        }

        .form-group.custom-select-group {
          position: relative;
        }

        /* Custom file input styling */
        .file-input {
          display: none;
        }

        .file-label {
          display: inline-block;
          padding: 10px 20px;
          font-size: 16px;
          cursor: pointer;
          border: 1px solid #ccc;
          border-radius: 10px;
          text-align: center;
          background-color: white;
          width: 100%;
          box-sizing: border-box;
        }

        /* .file-label:hover {
        background-color: #f0f0f0;
      } */

        /* .file-name {
        margin-top: 10px;
        font-size: 14px;
      } */
        .file-container {
          border: 2px dashed #ccc;
          padding: 20px;
          text-align: center;
          border-radius: 10px;
          position: relative;
          transition: background-color 0.3s, border-color 0.3s;
        }

        .file-container.dragging {
          background-color: #f0f0f0;
          border-color: #007bff;
        }

        .file-label {
          display: block;
          cursor: pointer;
          color: #333;
        }

        .file-list {
          margin-top: 10px;
        }

        .file-list ul {
          list-style-type: none;
          padding-left: 0;
        }

        .file-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
          padding: 10px;
          border: 1px solid #ddd;
          border-radius: 8px;
          transition: background-color 0.3s;
        }

        .file-item:hover {
          background-color: #f9f9f9;
        }

        .file-info {
          display: flex;
          align-items: center;
        }

        .file-info svg {
          margin-right: 10px;
          fill: #007bff;
        }

        .remove-btn {
          background-color: #ff4d4d;
          color: white;
          border: none;
          padding: 5px 10px;
          cursor: pointer;
          border-radius: 5px;
          font-size: 14px;
          transition: background-color 0.3s;
        }

        .remove-btn:hover {
          background-color: #ff0000;
        }

        .file-name {
          margin-top: 10px;
          font-size: 14px;
          color: #666;
        }

        /* updated css */
        .form-container input,
        .form-container textarea,
        .form-container .file-container {
          width: 100%; /* Ensure full width */
          box-sizing: border-box; /* Include padding and borders in the element's total width */
        }

        .file-container {
          display: block; /* Ensure the file container respects width rules */
          margin-bottom: 15px; /* Add margin if needed */
        }

        .file-label {
          width: 100%; /* Ensure the file label takes up the full width */
        }

        .form-group {
          width: 100%; /* Ensure each form group takes full width */
        }

        .double-row .form-group {
          width: 46%; /* Make sure double-row form elements are aligned correctly */
        }

        /* Ensure custom-select component respects width and alignment */
        .custom-select-group,
        .custom-select {
          width: 100%;
        }

        .custom-select-toggle {
          width: 100%; /* Full width for the dropdown toggle */
          box-sizing: border-box;
        }

        .custom-select-options {
          width: 100%; /* Make sure the dropdown options also take full width */
        }

        /* Adjust textarea width and allow user to resize height */
        textarea {
          width: 100%;
          box-sizing: border-box;
          resize: vertical; /* Allow users to adjust height but not width */
          min-height: 100px; /* Set a reasonable default height */
        }

        .success-overlay {
          width: 100%;
          height: 40vh;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 2em;
        }
      
        .success-message-box {
          background: white;
          padding: 1em;
          text-align: center;
        }
      
        .success-message-box p {
          font-size: 16px;
          margin-bottom: 2em;
        }
        .success-message-box h2{
          font-size: 2em;
        }
      
        .success-message-box button {
          background-color: #18395d;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 5px;
          cursor: pointer;
        }
      
        .success-message-box button:hover {
          background-color: #4c7baf;
        }

        .input-error {
          border-color: red;
        }
        

        .error-message {
          color: red;
         font-size: 0.9em;
        }

        .required {
          color: red;
          margin-left: 5px; /* Optional: Adds some spacing between the label and the asterisk */
        }
        
        /* Loading State Styles */
        .loading-state-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(255, 255, 255, 0.9);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
        }

        .loading-state {
          text-align: center;
          padding: 20px;
          border-radius: 8px;
        }

        .loading-spinner {
          width: 50px;
          height: 50px;
          border: 5px solid #f3f3f3;
          border-top: 5px solid #3498db;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin: 0 auto 20px;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .loading-state p {
          font-size: 18px;
          color: #333;
          margin: 0;
        }
      `;
      document.head.appendChild(style);
    },
  };
  